module.exports = __webpack_public_path__ + "static/media/download-bg-banner-graphic.c75a4a55.png";